__webpack_require__.p = "https://beta.na.safety-genie.whs.amazon.dev/";